import React from 'react';

export default function Privacy() {
    return (
        <div className="policy-page">
            <div className="policy-container">
                <h1>Privacy Policy</h1>
                <p className="policy-updated">Last Updated: January 2025</p>

                <section className="policy-section">
                    <h2>Introduction</h2>
                    <p>
                        Big Hit Barbershop ("we," "our," or "us") respects your privacy and is committed
                        to protecting your personal information. This Privacy Policy explains how we
                        collect, use, disclose, and safeguard your information when you visit our
                        website or use our services.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>Information We Collect</h2>
                    <h3>Personal Information</h3>
                    <p>We may collect personal information that you voluntarily provide, including:</p>
                    <ul>
                        <li>Name and contact information (phone number, email address)</li>
                        <li>Appointment preferences and history</li>
                        <li>Payment information (processed securely through third-party providers)</li>
                        <li>Communication preferences</li>
                    </ul>

                    <h3>Automatically Collected Information</h3>
                    <p>When you visit our website, we may automatically collect:</p>
                    <ul>
                        <li>Browser type and version</li>
                        <li>Operating system</li>
                        <li>IP address</li>
                        <li>Pages visited and time spent on pages</li>
                        <li>Referring website addresses</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <h2>How We Use Your Information</h2>
                    <p>We use the information we collect to:</p>
                    <ul>
                        <li>Schedule and manage your appointments</li>
                        <li>Communicate with you about your appointments and our services</li>
                        <li>Process payments for services rendered</li>
                        <li>Send promotional offers and updates (with your consent)</li>
                        <li>Improve our website and services</li>
                        <li>Respond to your inquiries and provide customer support</li>
                        <li>Comply with legal obligations</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <h2>Information Sharing</h2>
                    <p>
                        We do not sell, trade, or rent your personal information to third parties.
                        We may share your information with:
                    </p>
                    <ul>
                        <li><strong>Service Providers:</strong> Third-party companies that help us operate
                            our business (e.g., appointment booking platforms, payment processors)</li>
                        <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
                        <li><strong>Business Transfers:</strong> In connection with a merger, acquisition,
                            or sale of assets</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <h2>Third-Party Services</h2>
                    <p>
                        Our website may contain links to third-party websites and services, including
                        our booking platform (GetSquire), social media pages, and review platforms.
                        These third parties have their own privacy policies, and we encourage you to
                        review them. We are not responsible for the privacy practices of these external sites.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>Data Security</h2>
                    <p>
                        We implement appropriate technical and organizational measures to protect your
                        personal information against unauthorized access, alteration, disclosure, or
                        destruction. However, no method of transmission over the internet is 100% secure,
                        and we cannot guarantee absolute security.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>Your Rights</h2>
                    <p>Depending on your location, you may have the right to:</p>
                    <ul>
                        <li>Access the personal information we hold about you</li>
                        <li>Request correction of inaccurate information</li>
                        <li>Request deletion of your personal information</li>
                        <li>Opt-out of marketing communications</li>
                        <li>Withdraw consent where processing is based on consent</li>
                    </ul>
                    <p>
                        To exercise any of these rights, please contact us using the information provided below.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>Cookies</h2>
                    <p>
                        Our website may use cookies and similar tracking technologies to enhance your
                        browsing experience. You can set your browser to refuse cookies, but this may
                        limit some features of our website.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>Children's Privacy</h2>
                    <p>
                        Our services are available to individuals of all ages, but we do not knowingly
                        collect personal information from children under 13 without parental consent.
                        If you believe we have collected information from a child under 13, please
                        contact us immediately.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. We will notify you of any
                        changes by posting the new Privacy Policy on this page and updating the
                        "Last Updated" date. We encourage you to review this policy periodically.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>Contact Us</h2>
                    <p>
                        If you have questions or concerns about this Privacy Policy or our data practices,
                        please contact us:
                    </p>
                    <div className="policy-contact">
                        <p><strong>Las Vegas:</strong> (702) 675-6448</p>
                        <p>5651 S Grand Canyon Dr Suite 105, Las Vegas, NV 89148</p>
                        <br />
                        <p><strong>Kenosha:</strong> (262) 657-5055</p>
                        <p>6011 39th Ave, Kenosha, WI 53142</p>
                    </div>
                </section>
            </div>
        </div>
    );
}
